const GHOST_BASE_URL = (import.meta.env.VITE_GHOST_BASE_URL || '').replace(/\/$/, '');
const GHOST_CONTENT_API_KEY = import.meta.env.VITE_GHOST_CONTENT_API_KEY || '';

function buildUrl(path, params = {}) {
  if (!GHOST_BASE_URL || !GHOST_CONTENT_API_KEY) {
    throw new Error('Ghost API is not configured. Set VITE_GHOST_BASE_URL and VITE_GHOST_CONTENT_API_KEY.');
  }

  const url = new URL(`/ghost/api/content/${path}`, GHOST_BASE_URL);
  url.searchParams.set('key', GHOST_CONTENT_API_KEY);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

async function requestGhost(path, params = {}, signal) {
  const response = await fetch(buildUrl(path, params), { signal });
  if (!response.ok) {
    throw new Error(`Ghost request failed with status ${response.status}`);
  }

  const payload = await response.json();
  return payload.posts || [];
}

export async function fetchGhostPosts({ limit = 12, filter = '', order = 'published_at desc' } = {}, signal) {
  return requestGhost(
    'posts/',
    {
      include: 'tags,authors',
      fields: 'id,title,slug,excerpt,custom_excerpt,feature_image,published_at,reading_time',
      limit,
      order,
      filter,
    },
    signal,
  );
}

export async function fetchGhostPostBySlug(slug, signal) {
  const posts = await requestGhost(
    `posts/slug/${encodeURIComponent(slug)}/`,
    {
      include: 'tags,authors',
      formats: 'html',
    },
    signal,
  );

  return posts[0] || null;
}
